import { documentConstants } from './document.constants'

const initialState = {
  loadingBoatDocumentsFromEquipment: false,
  boatDocumentsFromEquipmentError: null,
  boatDocumentsFromEquipment: [],

  boatDocuments: [],
  equipmentDocuments: [],
  documentCategories: [],
  loadingDocuments: false,
  loading: false,
  loadingDocumentsForDashboard: false,
  documentsForDashboard: [],

  savingDocumentDashboardStatus: false,
  error: null,

  savingBoatDocuments: {
    totalNumberOfDocuments: 0,
    totalSavedDocuments: 0,
  },
}

export function documents(state = initialState, action) {
  switch (action.type) {
    case documentConstants.REQUEST_START:
      return {
        ...state,
        loading: true,
      }
    case documentConstants.REQUEST_STOP:
      return {
        ...state,
        loading: false,
      }
    case documentConstants.REQUEST_ERROR:
      return {
        ...state,
        error: action.error,
        loading: true,
      }
    case documentConstants.FETCH_BOAT_DOCUMENTS:
      return {
        ...state,
      }
    case documentConstants.FETCH_BOAT_DOCUMENTS_FOR_EQUIPMENT:
      return {
        ...state,
        loadingBoatDocumentsFromEquipment: true,
        boatDocumentsFromEquipmentError: null,
        boatDocumentsFromEquipment: [],
      }
    case documentConstants.FETCH_BOAT_DOCUMENTS_FOR_EQUIPMENT_SUCCESS:
      return {
        ...state,
        loadingBoatDocumentsFromEquipment: false,
        boatDocumentsFromEquipmentError: null,
        boatDocumentsFromEquipment: action.boatDocumentsForEquipment,
      }
    case documentConstants.FETCH_BOAT_DOCUMENTS_FOR_EQUIPMENT_ERROR:
      return {
        ...state,
        loadingBoatDocumentsFromEquipment: false,
        boatDocumentsFromEquipmentError: action.error,
        boatDocumentsFromEquipment: [],
      }
    case documentConstants.FETCH_BOAT_DOCUMENTS_SUCCESS:
      return {
        ...state,
        boatDocuments: action.boatDocuments,
      }

    case documentConstants.FETCH_BOAT_DOCUMENTS_ERROR:
      return {
        ...state,
        error: action.error,
      }

    case documentConstants.FETCH_DOCUMENTS_FOR_DASHBOARD:
      return {
        ...state,
        loadingDocumentsForDashboard: true,
      }
    case documentConstants.FETCH_DOCUMENTS_FOR_DASHBOARD_SUCCESS:
      return {
        ...state,
        loadingDocumentsForDashboard: false,
        documentsForDashboard: action.documents,
      }

    case documentConstants.FETCH_DOCUMENTS_FOR_DASHBOARD_ERROR:
      return {
        ...state,
        loadingDocumentsForDashboard: false,
        error: action.error,
      }

    case documentConstants.SAVING_NEW_DOCUMENT:
      return {
        ...state,
      }

    case documentConstants.SAVING_NEW_DOCUMENT_SUCCESS:
      return {
        ...state,
      }

    case documentConstants.SAVING_NEW_DOCUMENT_ERROR:
      return {
        ...state,
        error: action.error,
      }

    case documentConstants.SAVING_DOCUMENTS_LOADING:
      return {
        ...state,
        savingBoatDocumentsError: null,
        savingBoatDocuments: {
          ...state.savingBoatDocuments,
          totalNumberOfDocuments: action.numberOfDocuments,
          totalSavedDocuments: 0,
        },
      }
    case documentConstants.SAVING_DOCUMENTS_SUCCESS:
      return {
        ...state,
        savingBoatDocuments: {
          ...state.savingBoatDocuments,
          totalSavedDocuments: state.savingBoatDocuments.totalSavedDocuments + 1,
        },
      }
    case documentConstants.SAVING_DOCUMENTS_ERROR:
      return {
        ...state,
        savingBoatDocumentsError: action.error,
      }

    case documentConstants.FETCH_DOCUMENT_CATEGORIES:
      return {
        ...state,
        loading: true,
      }
    case documentConstants.FETCH_DOCUMENT_CATEGORIES_SUCCESS:
      return {
        ...state,
        loading: false,
        documentCategories: action.DocumentCategories,
      }

    case documentConstants.FETCH_DOCUMENT_CATEGORIES_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      }
    case documentConstants.FETCH_DOCUMENT_USER_CATEGORIES:
      return {
        ...state,
        loading: true,
      }
    case documentConstants.FETCH_DOCUMENT_USER_CATEGORIES_SUCCESS:
      return {
        ...state,
        loading: false,
        documentUserCategories: action.documentUserCategories,
      }

    case documentConstants.FETCH_DOCUMENT_USER_CATEGORIES_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      }

    case documentConstants.UPDATE_DOCUMENT_DASHBOARD_STATUS:
      return {
        ...state,
        savingDocumentDashboardStatus: true,
      }
    case documentConstants.UPDATE_DOCUMENT_DASHBOARD_STATUS_SUCCESS:
      return {
        ...state,
        savingDocumentDashboardStatus: false,
      }

    case documentConstants.UPDATE_DOCUMENT_DASHBOARD_STATUS_ERROR:
      return {
        ...state,
        savingDocumentDashboardStatus: false,
        error: action.error,
      }
    case documentConstants.RESET_DOCUMENTS:
      return {
        ...state,
        boatDocuments: [],
        equipmentDocuments: [],
        documentCategories: [],
        documentsForDashboard: [],
      }

    default:
      return state
  }
}
